// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  padding: 40px;
  color: white;
}

.App-header h1 {
  margin: 0;
  font-size: 3rem;
}

.App-header p {
  font-size: 1.2rem;
  margin: 10px 0 30px 0;
}

.App-header nav {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.App-header a {
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  transition: color 0.3s;
}

.App-header a:hover {
  color: #61dafb;
}

main {
  padding: 60px 20px;
  max-width: 1000px;
  margin: 0 auto;
}

section {
  margin: 40px 0;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

section h2 {
  color: #282c34;
  margin-top: 0;
}

section ul {
  list-style: none;
  padding: 0;
}

section li {
  padding: 10px;
  margin: 5px 0;
  background-color: white;
  border-left: 4px solid #61dafb;
}

footer {
  background-color: #282c34;
  color: white;
  padding: 20px;
  margin-top: 40px;
}

/* Blog Styles */
.blog-posts-list {
  display: grid;
  gap: 20px;
}

.blog-post-card {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid #61dafb;
}

.blog-post-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.blog-post-card h3 {
  color: #282c34;
  margin: 0 0 10px 0;
}

.blog-post-card time {
  color: #666;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 10px;
}

.blog-post-card p {
  color: #555;
  line-height: 1.6;
  margin: 10px 0;
}

.read-more {
  background-color: #61dafb;
  color: #282c34;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.read-more:hover {
  background-color: #4fa8c5;
  color: white;
}

.blog-post-detail {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
}

.back-button {
  background-color: #282c34;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #61dafb;
  color: #282c34;
}

.blog-post-detail article {
  line-height: 1.8;
}

.blog-post-detail article h3 {
  color: #282c34;
  font-size: 2rem;
  margin: 20px 0 10px 0;
}

.blog-post-detail article time {
  color: #666;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 20px;
}

.blog-post-detail article p {
  color: #555;
  margin: 15px 0;
}

.auth-panel {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.auth-error {
  color: #b00020;
  margin: 0;
}

.auth-warning {
  color: #8a5a00;
}

.admin-session {
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: space-between;
}

.admin-session img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.admin-welcome {
  margin: 0;
  font-weight: 700;
  color: #282c34;
}

.admin-email {
  margin: 4px 0 0 0;
  color: #666;
  font-size: 0.95rem;
}

.admin-session-wrap {
  display: grid;
  gap: 16px;
}

.admin-form {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
}

.admin-form h3 {
  margin-top: 0;
  color: #282c34;
}

.admin-form input,
.admin-form textarea,
.admin-form select {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 0.95rem;
}

.admin-post-list {
  margin: 0;
  padding-left: 18px;
  color: #444;
}

.admin-post-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.post-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.post-status-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
}

.post-status-badge.draft {
  background-color: #fff4db;
  color: #7a4b00;
}

.post-status-badge.published {
  background-color: #dcfce7;
  color: #166534;
}

.draft-preview-banner {
  margin: 10px 0;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: #fff4db;
  color: #7a4b00;
  font-weight: 700;
}

.secondary-button,
.danger-button {
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 700;
}

.secondary-button {
  background-color: #eceff3;
  color: #1f2937;
  margin-top: 10px;
}

.secondary-button:hover {
  background-color: #d9dee5;
}

.danger-button {
  background-color: #b00020;
  color: #fff;
}

.danger-button:hover {
  background-color: #93001a;
}

.danger-button:disabled,
.secondary-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.status-success {
  margin: 8px 0 0;
  color: #1a7f37;
  font-weight: 600;
  word-break: break-word;
}

.status-error {
  margin: 8px 0 0;
  color: #b00020;
  font-weight: 600;
}

.rich-editor-shell {
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  margin-bottom: 10px;
}

.rich-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.rich-editor-toolbar .secondary-button {
  margin-top: 0;
}

.rich-editor-content {
  min-height: 220px;
  padding: 12px;
}

.rich-editor-content .ProseMirror {
  min-height: 180px;
  outline: none;
  text-align: left;
}

.rich-editor-content .ProseMirror p.is-editor-empty:first-child::before {
  color: #9ca3af;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}

.rich-editor-content .ProseMirror img,
.rich-editor-content .ProseMirror video {
  max-width: 100%;
  height: auto;
}

.media-picker-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 10px;
  align-items: end;
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.media-picker-row label {
  display: grid;
  gap: 6px;
  color: #374151;
  font-size: 0.9rem;
  text-align: left;
}

.media-picker-row select {
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
}

.media-library-summary {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.media-library-summary .secondary-button {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 40px;\n  color: white;\n}\n\n.App-header h1 {\n  margin: 0;\n  font-size: 3rem;\n}\n\n.App-header p {\n  font-size: 1.2rem;\n  margin: 10px 0 30px 0;\n}\n\n.App-header nav {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n\n.App-header a {\n  color: white;\n  text-decoration: none;\n  font-size: 1.1rem;\n  transition: color 0.3s;\n}\n\n.App-header a:hover {\n  color: #61dafb;\n}\n\nmain {\n  padding: 60px 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\nsection {\n  margin: 40px 0;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\nsection h2 {\n  color: #282c34;\n  margin-top: 0;\n}\n\nsection ul {\n  list-style: none;\n  padding: 0;\n}\n\nsection li {\n  padding: 10px;\n  margin: 5px 0;\n  background-color: white;\n  border-left: 4px solid #61dafb;\n}\n\nfooter {\n  background-color: #282c34;\n  color: white;\n  padding: 20px;\n  margin-top: 40px;\n}\n\n/* Blog Styles */\n.blog-posts-list {\n  display: grid;\n  gap: 20px;\n}\n\n.blog-post-card {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-left: 4px solid #61dafb;\n}\n\n.blog-post-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.blog-post-card h3 {\n  color: #282c34;\n  margin: 0 0 10px 0;\n}\n\n.blog-post-card time {\n  color: #666;\n  font-size: 0.9rem;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.blog-post-card p {\n  color: #555;\n  line-height: 1.6;\n  margin: 10px 0;\n}\n\n.read-more {\n  background-color: #61dafb;\n  color: #282c34;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.3s;\n  margin-top: 10px;\n}\n\n.read-more:hover {\n  background-color: #4fa8c5;\n  color: white;\n}\n\n.blog-post-detail {\n  background-color: white;\n  padding: 30px;\n  border-radius: 8px;\n}\n\n.back-button {\n  background-color: #282c34;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  font-size: 1rem;\n  transition: background-color 0.3s;\n}\n\n.back-button:hover {\n  background-color: #61dafb;\n  color: #282c34;\n}\n\n.blog-post-detail article {\n  line-height: 1.8;\n}\n\n.blog-post-detail article h3 {\n  color: #282c34;\n  font-size: 2rem;\n  margin: 20px 0 10px 0;\n}\n\n.blog-post-detail article time {\n  color: #666;\n  font-size: 0.9rem;\n  display: block;\n  margin-bottom: 20px;\n}\n\n.blog-post-detail article p {\n  color: #555;\n  margin: 15px 0;\n}\n\n.auth-panel {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.auth-error {\n  color: #b00020;\n  margin: 0;\n}\n\n.auth-warning {\n  color: #8a5a00;\n}\n\n.admin-session {\n  background-color: white;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  justify-content: space-between;\n}\n\n.admin-session img {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.admin-welcome {\n  margin: 0;\n  font-weight: 700;\n  color: #282c34;\n}\n\n.admin-email {\n  margin: 4px 0 0 0;\n  color: #666;\n  font-size: 0.95rem;\n}\n\n.admin-session-wrap {\n  display: grid;\n  gap: 16px;\n}\n\n.admin-form {\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: left;\n}\n\n.admin-form h3 {\n  margin-top: 0;\n  color: #282c34;\n}\n\n.admin-form input,\n.admin-form textarea,\n.admin-form select {\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.admin-post-list {\n  margin: 0;\n  padding-left: 18px;\n  color: #444;\n}\n\n.admin-post-list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.post-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.post-status-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.post-status-badge.draft {\n  background-color: #fff4db;\n  color: #7a4b00;\n}\n\n.post-status-badge.published {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.draft-preview-banner {\n  margin: 10px 0;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background-color: #fff4db;\n  color: #7a4b00;\n  font-weight: 700;\n}\n\n.secondary-button,\n.danger-button {\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.secondary-button {\n  background-color: #eceff3;\n  color: #1f2937;\n  margin-top: 10px;\n}\n\n.secondary-button:hover {\n  background-color: #d9dee5;\n}\n\n.danger-button {\n  background-color: #b00020;\n  color: #fff;\n}\n\n.danger-button:hover {\n  background-color: #93001a;\n}\n\n.danger-button:disabled,\n.secondary-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.status-success {\n  margin: 8px 0 0;\n  color: #1a7f37;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.status-error {\n  margin: 8px 0 0;\n  color: #b00020;\n  font-weight: 600;\n}\n\n.rich-editor-shell {\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  background: #fff;\n  margin-bottom: 10px;\n}\n\n.rich-editor-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rich-editor-toolbar .secondary-button {\n  margin-top: 0;\n}\n\n.rich-editor-content {\n  min-height: 220px;\n  padding: 12px;\n}\n\n.rich-editor-content .ProseMirror {\n  min-height: 180px;\n  outline: none;\n  text-align: left;\n}\n\n.rich-editor-content .ProseMirror p.is-editor-empty:first-child::before {\n  color: #9ca3af;\n  content: attr(data-placeholder);\n  float: left;\n  height: 0;\n  pointer-events: none;\n}\n\n.rich-editor-content .ProseMirror img,\n.rich-editor-content .ProseMirror video {\n  max-width: 100%;\n  height: auto;\n}\n\n.media-picker-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 10px;\n  align-items: end;\n  padding: 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.media-picker-row label {\n  display: grid;\n  gap: 6px;\n  color: #374151;\n  font-size: 0.9rem;\n  text-align: left;\n}\n\n.media-picker-row select {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.media-library-summary {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.media-library-summary .secondary-button {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
